import { padNumberToLength } from '../utils/pad-number-to-length';
/**
 * Returns a numerical representation of the 1/10 of second: 0, 1, ..., 9
 * @hidden
 */
export const getTenthsOfSecond = ({ date }) => {
    return Math.floor(date.getMilliseconds() / 100);
};
/**
 * Returns a two-digit string representation of the 1/100 of second: 00, 01, ..., 99
 * @hidden
 */
export const getHundredthsOfSecond = ({ date }) => {
    return padNumberToLength(Math.floor(date.getMilliseconds() / 10), 2);
};
/**
 * Returns a three-digit string representation of the milliseconds: 000, 001, ..., 999
 * @hidden
 */
export const getMilliseconds = ({ date }) => {
    return padNumberToLength(date.getMilliseconds(), 3);
};
//# sourceMappingURL=fractional-seconds.js.map